import React, { useState } from "react";
import people from "./data";
import { FaChevronLeft, FaChevronRight, FaQuoteRight } from "react-icons/fa";

const Review = () => {
  //state value for picking the review
  const [index, setIndex] = useState(0);

  const { name, job, image, text } = people[index];

  const prevPerson = () => {
    index === 0 ? setIndex(people.length - 1) : setIndex(index - 1);
  };

  const nextPerson = () => {
    index === people.length - 1 ? setIndex(0) : setIndex(index + 1);
  };

  const surpriseMePerson = () => {
    let randomNumber = Math.floor(Math.random() * people.length);
    randomNumber === index
      ? setIndex(Math.floor(Math.random() * people.length))
      : setIndex(randomNumber);
  };

  return (
    <article className="review">
      <div className="img-container">
        <img src={image} alt={name} className="person-img"></img>
        <span>
          <FaQuoteRight className="quote-icon"></FaQuoteRight>
        </span>
      </div>
      <h3 className="author">{name}</h3>
      <p className="job">{job}</p>
      <p className="info">{text}</p>

      <div className="button-container">
        <button className="prev-btn" onClick={prevPerson}>
          <FaChevronLeft />
        </button>
        <button className="next-btn" onClick={nextPerson}>
          <FaChevronRight />
        </button>
      </div>
      <button className="random-btn" onClick={surpriseMePerson}>
        Surprise Me!
      </button>
    </article>
  );
};

export default Review;
